import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRightOutlined } from '@ant-design/icons'
import { TEXT_CONSTANTS } from '../constants/Constants'; // Ensure this file is correctly imported

const Navigation = () => {
  const navigate = useNavigate();

  const handleRedirection = (routeName) => {
    navigate(routeName);
  };

  return (
    <div className="min-h-screen flex flex-col md:flex-row items-center justify-center gap-8 px-6 py-8 bg-[#1F405A] text-white">
      <section className="flex flex-col justify-end bg-[#FFFFFF] p-4 md:w-[25%] md:h-[380px] border rounded-md w-[60%] h-[450px] mt-8 text-black">
      <div className="m-auto flex items-center justify-center">
      <span className="m-auto text-center">{TEXT_CONSTANTS.SUSTAINABILITY_INFO_TEXT}</span>
      </div>
      
      <button
        onClick={()=>handleRedirection('sustainability-home')}
        className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg text-lg transition duration-300 ease-in-out transform hover:scale-105"
      >
        {TEXT_CONSTANTS.SUSTAINABILITY_APP_LINK} <ArrowRightOutlined />
      </button>
      </section>
      <section className="flex flex-col justify-end bg-[#FFFFFF] p-4 md:w-[25%] md:h-[380px] border rounded-md w-[60%] h-[450px] mt-8 text-black">
      <div className="m-auto flex items-center justify-center">
      <span className="m-auto text-center">{TEXT_CONSTANTS.WATCH_TOWER_INFO_TEXT}</span>
      </div>
      
      <button
        onClick={()=>handleRedirection('watchtower')}
        className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg text-lg transition duration-300 ease-in-out transform hover:scale-105"
      >
        {TEXT_CONSTANTS.WATCH_TOWER_APP_LINK} <ArrowRightOutlined />
      </button>
      </section>
      <section className="flex flex-col justify-end bg-[#FFFFFF] p-4 md:w-[25%] md:h-[380px] border rounded-md w-[60%] h-[450px] mt-8 text-black">
      <div className="m-auto flex items-center justify-center">
      <span className="m-auto text-center">{TEXT_CONSTANTS.LOGBOOK_INFO_TEXT}</span>
      </div>
      <button
        onClick={()=>handleRedirection('/logbook/login')}
        className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg text-lg transition duration-300 ease-in-out transform hover:scale-105"
      >
        {TEXT_CONSTANTS.LOGBOOK} <ArrowRightOutlined />
      </button>
      </section>
      <section className="flex flex-col justify-end bg-[#FFFFFF] p-4 md:w-[25%] md:h-[380px] border rounded-md w-[60%] h-[450px] mt-8 text-black">
      <div className="m-auto flex items-center justify-center">
      <span className="m-auto text-center">{TEXT_CONSTANTS.EPM_INFO_TEXT}</span>
      </div>
      <button
        onClick={()=>handleRedirection('subapp')}
        className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg text-lg transition duration-300 ease-in-out transform hover:scale-105"
      >
        {TEXT_CONSTANTS.EPM_APP_LINK} <ArrowRightOutlined />
      </button>
      </section>
    </div>
  );
};

export default Navigation;
